"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _TagLock = _interopRequireDefault(require("@rsuite/icon-font/lib/application/TagLock"));

// Generated by script, don't edit it please.
var TagLock = (0, _createSvgIcon["default"])({
  as: _TagLock["default"],
  ariaLabel: 'tag lock',
  category: 'application',
  displayName: 'TagLock'
});
var _default = TagLock;
exports["default"] = _default;
module.exports = exports.default;